import React from 'react'

import type { CutReadStrength } from '@digital-twins/shared-types/reporting'

const SECONDARY = 'var(--slide-text-secondary, #384242)'
const TRACK = 'var(--slide-neutral-light, #EDF2F7)'
const RULE = 'var(--slide-border-soft, #E2E2E2)'

/**
 * How strong a computed cut's difference reads, as a neutral pill in reader
 * words. The label arrives translated from the builder (deck-ui has no
 * translation runtime); the pill never prints a p-value and never takes a
 * good or bad colour: "No real difference" is often the finding.
 *
 * Shared by every slide that draws a cut (the split choice bars).
 */
export function ReadPill(props: {
  read: CutReadStrength
  label: string
  testId: string
  style?: React.CSSProperties
}) {
  return (
    <span
      data-testid={props.testId}
      data-read-strength={props.read}
      style={{
        display: 'inline-block',
        padding: '5px 12px',
        borderRadius: 999,
        border: `1px solid ${RULE}`,
        background: TRACK,
        color: SECONDARY,
        fontSize: 14,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
        ...props.style,
      }}
    >
      {props.label}
    </span>
  )
}
